import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Alert,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import api from '../services/api';

const PayoutDialog = ({ open, payoutData, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    payment_method: 'check',
    payout_date: new Date().toISOString().split('T')[0],
    reference_number: '',
    notes: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await api.post('/api/consignments/payouts', {
        vendor_id: payoutData.vendor.id,
        consignment_ids: payoutData.consignment_ids,
        payment_method: formData.payment_method,
        payout_date: formData.payout_date,
        reference_number: formData.reference_number,
        notes: formData.notes,
      });

      onSuccess();
    } catch (error) {
      console.error('Error processing payout:', error);
      setError(error.response?.data?.error || 'Error processing payout');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Process Payout</DialogTitle>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box sx={{ mb: 3, mt: 1 }}>
            <Typography variant="subtitle1">
              <strong>Vendor:</strong> {payoutData.vendor.name}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Total Amount:</strong>{' '}
              <span style={{ color: 'green', fontSize: '1.2em' }}>
                ${parseFloat(payoutData.total_amount).toFixed(2)}
              </span>
            </Typography>
            <Typography variant="subtitle1">
              <strong>Items:</strong> {payoutData.items_count}
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth required>
                <InputLabel>Payment Method</InputLabel>
                <Select
                  name="payment_method"
                  value={formData.payment_method}
                  onChange={handleChange}
                  label="Payment Method"
                >
                  <MenuItem value="check">Check</MenuItem>
                  <MenuItem value="cash">Cash</MenuItem>
                  <MenuItem value="bank_transfer">Bank Transfer</MenuItem>
                  <MenuItem value="paypal">PayPal</MenuItem>
                  <MenuItem value="venmo">Venmo</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Payout Date"
                name="payout_date"
                type="date"
                value={formData.payout_date}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Reference Number"
                name="reference_number"
                value={formData.reference_number}
                onChange={handleChange}
                placeholder="Check #, Transaction ID, etc."
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Notes"
                name="notes"
                value={formData.notes}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained" color="success" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Process Payout'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PayoutDialog;
